module.exports = __webpack_public_path__ + "static/media/room2_1.e5be795f.JPG";